import React, { useEffect, useRef, useState } from 'react';
import ASBRSiteView from './overall/ASBRSiteView';
import BlueRoofSitePage from './site_page/BlueRoofSitePage';
import { useLocation } from 'react-router-dom';

const BlueRoofContainer = props => {
    const [containerHeight, setContainerHeight] = useState('95vh');
    const [specificSite, setSpecificSite] = useState(false);

    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;
        const seg = path.split('/').filter(Boolean).pop();
        const isNumeric = Number.isInteger(Number(seg));

        const isSpecific = path.startsWith('/blueroof') && isNumeric;
        setSpecificSite(isSpecific);
    }, [location.key, location.pathname]);

    useEffect(() => {
        const updateContainerHeight = () => {
            let navbar = document.querySelector('.navbar');
            let breadcrumbNav = document.getElementsByClassName('col s12 es-breadcrumb')[0];
  
            let navbarHeight = navbar.offsetHeight + breadcrumbNav.offsetHeight;
            let windowHeight = window.innerHeight;
            let remainingHeight = windowHeight - navbarHeight;
  
            setContainerHeight(`${remainingHeight}px`);
        };
      
        updateContainerHeight();
    
        window.addEventListener('resize', updateContainerHeight);
    
        return () => {
            window.removeEventListener('resize', updateContainerHeight);
        };
    }, []);

    return(
        <div style={{padding:'1% 2%', backgroundColor:'#f5f5f5', height: containerHeight, overflowX:'hidden'}}>
            {
                specificSite ? 
                <BlueRoofSitePage auth={props.auth}/>
                :
                <ASBRSiteView/>
            }
        </div>
    );
}

export default BlueRoofContainer;